import React, { useEffect, useRef, useState } from "react";
import styles from "./BeveragesGallery.module.css";
import { beverageCategories } from "./constants/beverage-categories";
import { Icon } from "../../components";
import clsx from "clsx";

export const BeveragesGallery = (props) => {
  const { categories = [], onAddClick, hideAddButton = false } = props;
  const scrolContainer = useRef(null);
  const [arrowsActiveElementsCount, setArrowsActiveElementsCount] = useState(0);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [maxScroll, setMaxScroll] = useState(0);

  const allCategories = [];

  for (let i = 0; i < 6; i++) {
    const category = categories[i];
    allCategories.push(category ?? null);
  }

  const getImageForCategory = (categoryName) => {
    return beverageCategories.find((beverage) => beverage.name === categoryName)?.icon;
  };

  const scroll = (delta) => {
    if (!scrolContainer?.current) {
      return;
    }

    scrolContainer.current.scrollTo({
      left: scrolContainer.current.scrollLeft + delta,
      behavior: "smooth",
    })
  };

  const scrollLeft = () => {
    scroll(-190);
  };

  const scrollRight = () => {
    scroll(190);
  };

  useEffect(() => {
    const resizeObeserver = new ResizeObserver(entries => {
      setArrowsActiveElementsCount(
        Math.floor(entries[0].target.clientWidth / 170)
      );
      if (scrolContainer.current) {
        setMaxScroll(scrolContainer.current.scrollWidth - scrolContainer.current.clientWidth);
      }
    });

    resizeObeserver.observe(scrolContainer.current);

    return () => {
      resizeObeserver.disconnect();
    }
  }, []);

  useEffect(() => {
    const container = scrolContainer.current;
    if (!container) return;

    const handleScroll = () => {
      setScrollPosition(container.scrollLeft);
      setMaxScroll(container.scrollWidth - container.clientWidth);
    };

    container.addEventListener('scroll', handleScroll);
    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return <div className={styles.beveragesGallery}>
    {!hideAddButton && (
      <button
        onClick={onAddClick}
        className={`${styles.addButton} custom_click_track`}
        data-custom_click_track_value="Beverages|Add Category|internal"
      ><span>+</span></button>
    )}
    <div ref={scrolContainer} className={styles.beveragesGalleryInner}>
      {allCategories.map((category, i) => <div key={i}
                                               className={`${styles.category} ${category ? styles.activeCategory : null}`}>
        {
          category ? <img src={getImageForCategory(category)} /> : null
        }
      </div>)}
    </div>
    {
      categories.length > arrowsActiveElementsCount ?
      <>
        <button
          className={clsx(styles.button, styles.buttonLeft, "custom_click_track")}
          data-custom_click_track_value="Beverages|Scroll Left|internal"
          onClick={scrollLeft}
          disabled={scrollPosition <= 0}
        >
          <Icon name="arrowRightNoLine" />
        </button>
        <button
          className={clsx(styles.button, styles.buttonRight, "custom_click_track")}
          data-custom_click_track_value="Beverages|Scroll Right|internal"
          onClick={scrollRight}
          disabled={scrollPosition >= maxScroll}
        >
          <Icon name="arrowRightNoLine" />
        </button>
      </> : null
    }
  </div>;
}